import React, { useState } from "react";
import { getImageUrlhttps } from "../../Utils/index";
import "../../Assets/Scss/CouponCard.scss";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import PlaceHolderImage from "../../Assets/Images/PlaceholderImage.png";
import CentralCouponRedirect from "../../Utils/CentralCouponRedirect";

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

const Div = styled.div`
  .coupon-code {
    // padding: 0.5rem;
    padding-left: 4.8rem;
    border: 2px solid #dddddd;
    background: linear-gradient(
        315deg,
        rgba(0, 0, 0, 0.06) 10%,
        transparent 15%,
        transparent 35%,
        rgba(0, 0, 0, 0.06) 40%,
        rgba(0, 0, 0, 0.06) 60%,
        transparent 65%,
        transparent 85%,
        rgba(0, 0, 0, 0.06) 90%
      )
      repeat scroll 0 0/6px 6px transparent;

    position: relative;
    width: 125px;
    height: 40px;
    overflow: hidden;
  }

  .get-code {
    position: absolute;
    border-radius: 4px 0 0 4px;
    left: -2px;
    top: -2px;
    padding: 0.5rem;
    background: ${(props) => props.color};
    color: #ffffff;
    text-align: right;
    line-height: 1.5;
    white-space: nowrap;
    height: calc(100% + 2px);
  }

  .get-code:after {
    content: "";
    display: block;
    width: 0;
    height: 100%;
    border-top: 43px solid transparent;
    border-left: 32px solid ${(props) => props.color};
    position: absolute;
    right: -32px;
    top: 0;
    height: 35px;
  }

  .get-code:hover {
    padding-right: 0.45px;
    transition: all 0.5s ease;
  }
`;

function CouponCard({ coupon, history }) {
  const showfullText = false;

  const { domainData } = useSelector((state) => state.Website);
  const [useRedirectComponent, setUseRedirectComponent] = useState(false);

  return (
    <ZoomInDiv className="d-flex align-items-center flex-column couponCard h-100">
      {useRedirectComponent && (
        <CentralCouponRedirect
          e={useRedirectComponent.e}
          coupon={useRedirectComponent.coupon}
          setUseRedirectComponent={setUseRedirectComponent}
        ></CentralCouponRedirect>
      )}
      <Link to={`/store/${coupon?.store_id?.slug}`}>
        <img
          src={getImageUrlhttps(
            coupon.image ? coupon?.image : coupon?.store_id?.image,
            PlaceHolderImage
          )}
          className="image"
          width="100%"
          alt={coupon?.["advertiser - name"]}
        />
      </Link>
      <div className="textContainer">
        <div>
          <h4
            className="card-heading"
            onClick={() => {
              if (history?.location?.pathname?.split("/")?.length > 2) {
                window.open(
                  `/couponsredirect/category/${
                    history?.location?.pathname?.split("/")[2]
                  }/coupon/${coupon?.store_id?.name.replace(" ", "")}/${
                    coupon?._id
                  }`
                );
              } else {
                window.open(
                  `/couponsredirect/${coupon?.store_id?.slug?.replace(
                    " ",
                    ""
                  )}/${coupon?._id}`
                );
              }
            }}
          >
            {showfullText
              ? coupon.title
              : coupon.title?.length > 27
              ? coupon.title?.substring(0, 27) + "..."
              : coupon.title}
          </h4>
          <p
            className="card-decription"
            style={{overFlow:"hidden"}}
            dangerouslySetInnerHTML={{
              __html:
                coupon?.description
            }}
          ></p>
        </div>
        <div style={{ display: "flex" }}>
          <Div
            color={domainData?.header_color}
            className="d-flex align-items-center "
          >
            <div
              className="coupon-code btn"
              // onClick={(e) => {
              //   e.preventDefault();

              //   if (history.location.pathname.split("/").length > 2) {
              //     window.open(
              //       `/couponsredirect/category/${
              //         history.location.pathname.split("/")[2]
              //       }/coupon/${coupon?.store_id?.name.replace(" ", "")}/${
              //         coupon?._id
              //       }`
              //     );
              //   } else {
              //     window.open(
              //       `/couponsredirect/${coupon?.store_id?.slug?.replace(
              //         " ",
              //         ""
              //       )}/${coupon?._id}`
              //     );
              //   }
              // }}
              onClick={(e) => {
                e.preventDefault();
                setUseRedirectComponent({ e, coupon });
              }}
              style={{ margin: "0.5rem" }}
            >
              <span
                className="code-text"
                rel="nofollow"
                style={{ fontSize: "13px" }}
              >
                {coupon?.coupon_code?.substring(
                  coupon?.coupon_code?.length - 4
                )}
              </span>{" "}
              <span
                className="get-code"
                style={{ fontSize: "13px", fontWeight: 500 }}
              >
                Show Code
              </span>
            </div>
          </Div>
        </div>
      </div>
    </ZoomInDiv>
  );
}

export default CouponCard;
